import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { StoreSyncDetail, StoreSyncStatus } from "../models/sync-status.model";
import { ConceptApiService } from '../services/concept.resource';
import { StoreSyncDetailsDialog } from './dialogs/store-sync-details-dialog';

@Component({
    selector: 'syncStatus',
    templateUrl: 'src/app/features/concepts/templates/sync-status.html',
    standalone: false
})
export class SyncStatusComponent {
    private conceptID: number;

    public captions: Record<string, string>;
    public stores: StoreSyncStatus[] = [];
    public filteredStores: StoreSyncStatus[] = [];
    public sNameAscending: boolean = true;
    public statusAscending: boolean = true;
    public mobileViewActive: boolean = true;
    public showLegend: boolean = false;
    public storeOnSync: number = 0;
    public storeOutSync: number = 0;
    public storeNoProv: number = 0;
    public storeNothing: number = 0;

    constructor(
        @Inject(ConceptApiService) private conceptApiService: ConceptApiService,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private actRoute: ActivatedRoute,
        @Inject(MatDialog) private dialog: MatDialog,
    ) {

    }

    ngOnInit(): void {
        this.actRoute.data.subscribe((data) => {
            this.captions = data.captions;
        });

        this.actRoute.params.subscribe((params) => {
            this.conceptID = +params['conceptID'];
        });

        this.mobileViewActive = window.innerWidth < 1024;
        this.showLegend = !this.mobileViewActive;
        window.onresize = () => {
            this.mobileViewActive = window.innerWidth < 1024;
            if (!this.mobileViewActive) {
                this.showLegend = true;
            }
        };

        this.conceptApiService.getSyncStatusOfStores(this.conceptID).then((stores: StoreSyncStatus[]) => {
            this.stores = stores;
            for (let store of this.stores) {
                store.syncStatus = this.getStatusColor(store);   
                if (store.syncStatus == 'color-green') {
                    this.storeOnSync += 1;
                } else if (store.syncStatus == 'color-red') {
                    this.storeOutSync += 1;
                } else if (store.syncStatus == 'color-orange') {
                    this.storeNoProv += 1;
                } else if (store.syncStatus == 'color-grey') {        
                    this.storeNothing += 1;
                }   
            }
            this.filteredStores = this.stores;
        });
    }

    goToStore(store: StoreSyncStatus): void {
        let details: StoreSyncDetail[] = [];
        this.conceptApiService.getStoreSyncDetails(store["StoreID"]).then((details: StoreSyncDetail[]) => {
            details = details;
        });
        if (details.length == 0) {
            return;
        }
        const dialogRef = this.dialog.open(StoreSyncDetailsDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '950vw',
            minWidth: '50vw',
            data: {
                store: store,
                details: details
            },
        });
    }

    changeOrder(sortType: string): void {
        if (sortType == 'storeName') {
            this.sNameAscending = !this.sNameAscending;
        }
        else if (sortType == 'statusColor') {
            this.statusAscending = !this.statusAscending;
        }
    }

    changedSearchText(searchStr: string): void {
        this.filteredStores = this.filterStores(searchStr);
    }

    toggleLegendView(): void {
        this.showLegend = !this.showLegend;
    }

    filterStores(searchStr: string): StoreSyncStatus[] {
        return this.stores.filter(store => 
            store.storeName.toLowerCase().includes(searchStr.toLowerCase())
        );
    }

    getStatusColor(store: StoreSyncStatus) {
        const baseNext64 = 1000000000000;
        if (store['NextNum64'] == baseNext64)
            return 'color-grey'
        else if (store['NextNum64'] > baseNext64 && store['DoneRecVersion'] == -1)
            return 'color-orange'
        else if (store['NextNum64'] == store['DoneRecVersion'])
            return 'color-green'
        else if (store['NextNum64'] != store['DoneRecVersion']) 
            return 'color-red';
    }
}

